import {FC, useContext, useState} from 'react';
import {useSetRecoilState} from 'recoil';
import {useForm} from 'react-hook-form';

import {Box, Button, Collapse, ListItemButton, ListItemIcon, ListItemText, Stack, Tooltip} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ControlledInput from '../../../../ui/controlled-input/ControlledInput';
import {ModalContainer} from '../../../modals/ModalContainer';
import {ConfirmAction} from '../../../modals/ConfirmAction';

import {DictionaryService} from '../../../../api/services/dictionary.service';

import {deviceTypesDictQueryTrigger} from '../../../../store/deviceTypes/atoms';

import {IDeviceTypesDict, IDeviceTypesDictPostBody} from '../../../../shared/types/deviceTypesDict.types';
import {colors} from '../../../../shared/colors';
import {ModalNewOrUpdateSubtype} from './ModalNewOrUpdateSubtype';
import {EventBusContext} from '../../../../providers/EventBus';

interface IDeviceSubtypeListItem {
  subtype: IDeviceTypesDict;
}

export const DeviceSubtypeListItem: FC<IDeviceSubtypeListItem> = ({subtype}) => {
  const triggerDeviceTypesQuery = useSetRecoilState(deviceTypesDictQueryTrigger);
  const {control} = useForm<IDeviceTypesDictPostBody>({
    defaultValues: {
      name: subtype.name,
      code: subtype.code,
      description: subtype.description,
    },
  });
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const {bus} = useContext(EventBusContext);

  const handleClick = () => {
    setOpen(!open);
  };

  const toggleModalToDelete = () => {
    setOpenDelete(!openDelete);
  };

  const toggleModalToUpdate = () => {
    setOpenUpdate(!openUpdate);
  };

  const handleDelete = async (setLoading: (bool: boolean) => void) => {
    setLoading(true);

    try {
      await DictionaryService.deleteDeviceType(subtype.code);

      triggerDeviceTypesQuery((v) => v + 1);

      setTimeout(() => {
        setLoading(false);
        toggleModalToDelete();
      }, 0);
    } catch (err: any) {
      bus?.emit('error', [err]);

      setLoading(false);
    }
  };

  return (
    <>
      <ListItemButton sx={{border: `1px solid ${colors['border--white--bg']}`}} onClick={handleClick}>
        <ListItemIcon>{open ? <ExpandLess /> : <ExpandMore />}</ListItemIcon>
        <ListItemText primary={subtype.name} />
      </ListItemButton>
      <Collapse
        sx={{p: '0 8px', border: `1px solid ${colors['border--white--bg']}`, borderTop: 0}}
        in={open}
        timeout="auto"
        unmountOnExit
      >
        <Stack sx={{p: '16px 0'}} direction="column" spacing={3}>
          <Stack direction="row" spacing={3}>
            <Tooltip title={subtype.name}>
              <Box>
                <ControlledInput name="name" control={control} size="small" label="Название" disabled />
              </Box>
            </Tooltip>
            <Tooltip title={subtype.code}>
              <Box>
                <ControlledInput name="code" control={control} size="small" label="Код подтипа" disabled />
              </Box>
            </Tooltip>
            <Stack direction="row" spacing={3}>
              <Button onClick={toggleModalToUpdate} variant="contained">
                Изменить
              </Button>
              <Button onClick={toggleModalToDelete} variant="contained" color="error">
                Удалить
              </Button>
            </Stack>
          </Stack>
          <ControlledInput control={control} name="description" disabled label="Комментарий" multiline rows={4} />
        </Stack>
        {openDelete && (
          <ModalContainer
            sideEffect={handleDelete}
            renderModal={(sideEffect, loading) => (
              <ConfirmAction
                loading={loading}
                open={openDelete}
                handleClose={toggleModalToDelete}
                handleSideEffect={sideEffect}
                title="Подтвердите удаление"
                buttonTitle="Удалить"
              />
            )}
          />
        )}
        {openUpdate && (
          <ModalNewOrUpdateSubtype
            subtype={subtype}
            open={openUpdate}
            handleClose={toggleModalToUpdate}
            variant="UPDATE"
          />
        )}
      </Collapse>
    </>
  );
};
